export enum OptionsEnum {
  No = 'No',
  Yes = 'Yes'
}
